import mathAverage from "shared/math-average"
import mathRound from "shared/math-round"

export default function calculateAverageMood(numbers) {
  const average = mathAverage(numbers)

  return average ? mathRound(average, 2) : null
}
